export default "__VITE_ASSET__CoKrsP$2__"